export default __webpack_public_path__ + "static/media/regions.b03324c9.svg";